import { Component, h, Prop } from '@stencil/core';
import { isDirRtl } from '@utils/utils';
import { mediaIconsDefault, mediaIconsRound, mediaIconsSquare } from '../vs-social-share-container/sharelinks';

export type shareButtonType = 'default' | 'round' | 'square';

@Component({
  tag: 'vs-social-share',
  shadow: false,
})
export class VsSocialShare {
  @Prop() socialChannel: string = '';

  @Prop() dataTestId?: string = '';

  @Prop() shareButtonType: shareButtonType = 'default';

  /**
   @shortDescription Link that shares to the media
   @controlName buttonLink */
  @Prop() buttonLink: string;

  /**
   @shortDescription If true, dir attribute is set to 'rtl'.
   @controlName right
   */
  @Prop() right?: boolean = isDirRtl();

  /**
   @shortDescription Adds text for share link label for screen reader
   @controlName shareAriaLabel
   */
  @Prop() shareAriaLabel: string = '';

  setIcon = (socialChannel: string): string => {
    switch (this.shareButtonType) {
      case 'default':
        return mediaIconsDefault[socialChannel];
      case 'round':
        return mediaIconsRound[socialChannel];
      case 'square':
        return mediaIconsSquare[socialChannel];
      default:
        return mediaIconsDefault[socialChannel];
    }
  };
  render() {
    return (
      <a
        href={this.buttonLink}
        aria-label={this.shareAriaLabel}
        data-icon={this.socialChannel}
        class="vs-share-anchor"
        {...(this.right && { dir: 'rtl' })}
        data-icon-type={this.shareButtonType}
        {...(this.dataTestId.length && { 'data-test-id': this.dataTestId })}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span class={'visa-icon ' + this.setIcon(this.socialChannel)}></span>
      </a>
    );
  }
}
